import React from "react";
import cx from "classnames";
import dayjs from "dayjs";
import styles from "./Banner.module.scss";
import { cloneDeep } from "lodash";
import { useSchedulingABVariant } from "../../utils/useSchedulingABVariant";

export interface BannerProps {
  bannerSetting: any | null;
}

export const DisplayBanner: React.FC<BannerProps> = ({
  bannerSetting,
}) => {
  const { isV3 } = useSchedulingABVariant();
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  let banner = bannerSetting;
  if(banner && banner.banner_start_at && banner.banner_end_at) {
    banner.banner_enabled = (dayjs() > dayjs(banner.banner_start_at) && dayjs() < dayjs(banner.banner_end_at))
  }
  React.useEffect(() => {
    if (!containerRef.current) return;
    const links = containerRef.current.querySelectorAll<HTMLAnchorElement>("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noreferrer");
    });
  }, [bannerSetting]);
  if (banner && banner.banner_enabled && banner.banner_message_html) {
    const styleMain = {
      color: banner.banner_text_color,
      backgroundColor: banner.banner_background_color,
      ["--banner-link-color" as any]: banner.banner_text_color
    }
    return (
      <div
        className={cx(styles.banner, { [styles.v3]: isV3 })}
        ref={containerRef}
        dangerouslySetInnerHTML={{
          __html: banner.banner_message_html.replace(/\u003C/g, "<").replace(/\u003/g, ">"),
        }}
        style={styleMain}
      />
    );
  } else {
    return null;
  }
};
